import {
  getSocialShareStats,
  SocialShareStatsResponse,
  SocialShareStatsArgs,
} from 'api/services';
import { UseQueryOptions, useQuery } from 'react-query';
import { SocialShareVideos } from '../types';
import { embedVideoQueries } from './queryKeys';
import {
  hasSocialShareStatsSelector,
  socialStatsSummarySelector,
  socialVideoInfoSelector,
  sortDescSocialVideoInfoSelector,
} from './selectors';

type QueryKey = ReturnType<typeof embedVideoQueries.videos>;

function useGetSocialShareStatistics<TData = SocialShareStatsResponse>(
  args?: SocialShareStatsArgs,
  opts?: Omit<
    UseQueryOptions<SocialShareStatsResponse, unknown, TData, QueryKey>,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery<SocialShareStatsResponse, unknown, TData, QueryKey>(
    embedVideoQueries.videos(args?.episodeId),
    ({ queryKey: [{ episodeId }] }) => getSocialShareStats({ episodeId }),
    opts,
  );
}

export function useSocialVideoInfo(args: SocialShareStatsArgs) {
  return useGetSocialShareStatistics<SocialShareVideos[]>(args, {
    select: socialVideoInfoSelector,
  });
}

export function useSortedSocialVideoInfo(args: SocialShareStatsArgs) {
  return useGetSocialShareStatistics<SocialShareVideos[]>(args, {
    select: sortDescSocialVideoInfoSelector,
  });
}

export function useCheckSocialShareStatistics(requestStatus?: boolean) {
  return useGetSocialShareStatistics<boolean>(
    {},
    { select: hasSocialShareStatsSelector, enabled: requestStatus },
  );
}

export function useGetSocialStatsSummary(episodeId?: string) {
  return useGetSocialShareStatistics(
    { episodeId },
    {
      select: socialStatsSummarySelector,
    },
  );
}
